export const contactContentStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  minHeight: "90vh",
  padding: "5rem 1rem",
  gap: "4rem",
};

export const contactIconStyle = {
  margin: "0 1rem",
  height: "3rem",
};

export const textAreaStyle = {
  padding: "1rem",
  fontSize: "1.25rem",
  width: 832,
  maxWidth: "90vw",
  border: "1px solid #e5e7eb",
};

export const submitButtonStyle = {
  backgroundColor: "#85cdcb",
  ":hover": {
    backgroundColor: "#85cdcb",
  },
};

export const submitButtonDarkModeStyle = {
  backgroundColor: "#950740",
  ":hover": {
    backgroundColor: "#950740",
    boxShadow: "1px 1px 6px 3px #1a1a1d",
  },
};
